import {
  Document,
  ITPABillHeaderRequest,
  ITPABillItemsRequest,
} from "../interfaces/ITPABills";
import Axios from "../utils/axiosInterceptor";
import { BILLING_APIS, LIST_DEFAULT_PAGE_SIZE } from "../utils/constants";
import { warningMessageModal } from "../utils/modalMessage";
import { errorMessage, warningMessage } from "../utils/notificationUtils";

export const TpaBillPostRequest = async (
  healthCareId: number,
  caseId: number,
  visitId: number,
  schemeMetaDataId: number,
  documentPaths: Array<Document>
): Promise<any> => {
  try {
    const payload = {
      healthCareId,
      caseId,
      visitId,
      schemeMetaDataId,
      documentPaths,
    };
    const resp = await Axios.post<any>(
      BILLING_APIS.TpaBillGeneratePostApi,
      payload
    );
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot generate tpa bill";
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const TpaBillGetRequest = async (
  healthCareId: number,
  tpaBillMappingId: number
): Promise<any> => {
  try {
    const payload = {
      healthCareId,
      tpaBillMappingId,
    };
    const resp = await Axios.post<any>(BILLING_APIS.TpaBillGetApi, payload);
    return resp.data;
  } catch (error: any) {
    const errorMsg = error?.response?.data?.message || "Cannot get tpa bill";
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const TpaBillPutRequest = async (
  healthCareId: number,
  caseId: number,
  visitId: number,
  schemeMetaDataId: number,
  tpaBillMappingId: number,
  tpaBillHeaderRequest: ITPABillHeaderRequest,
  tpaBillItemsRequests?: Array<ITPABillItemsRequest>
): Promise<any> => {
  try {
    const payload = {
      healthCareId,
      caseId,
      visitId,
      schemeMetaDataId,
      tpaBillMappingId,
      tpaBillHeaderRequest,
      tpaBillItemsRequests,
    };
    const resp = await Axios.put<any>(
      BILLING_APIS.TpaBillUpdatePutApi,
      payload
    );
    return resp.data;
  } catch (error: any) {
    const errorMsg = error?.response?.data?.message || "Cannot update tpa bill";
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

// export const changeBillStatus = async (
//   healthCareId: number ,
//   tpaBillMappingId: number ,
//   status: string
// ): Promise<any> => {
//   try {
//     const payload = {
//       healthCareId,
//       tpaBillMappingId,
//       status,
//     };
//     const resp = await Axios.post(BILLING_APIS.ChangeBillStatus, payload);
//     return resp.data;
//   } catch (error: any) {
//     const errorMsg =
//       error?.response?.data?.message || "ERROR IN UPDATING BILL STATUS";
//     errorMessage(errorMsg);
//     throw new Error(errorMsg);
//   }
// };

export const getTPABillList = async (
  healthCareId: number,
  caseId: number,
  visitId: number,
  filters: any
): Promise<any> => {
  try {
    const payload = {
      healthCareId,
      caseId,
      visitId,
    };
    const params = {
      pageNumber: filters?.pageNumber - 1 || 0,
      pageSize: filters?.pageSize || LIST_DEFAULT_PAGE_SIZE,
    };
    const resp = await Axios.post(BILLING_APIS.GetTPABillList, payload, {
      params: params,
    });
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "ERROR IN GETTING BILL LIST";
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const ChangeByFilterPutRequest = async (
  tpaBillMappingId: number,
  healthCareId: number,
  schemeMetaDataId: number,
  roomType?: string,
  hospitalRoomType?: string,
  filterBy?: string
): Promise<any> => {
  try {
    const payload = {
      tpaBillMappingId,
      healthCareId,
      schemeMetaDataId,
      roomType,
      hospitalRoomType,
      filterBy,
    };
    const resp = await Axios.put<any>(
      BILLING_APIS.UpdateByFilterPutApi,
      payload
    );
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot update bill by filter";
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

// export const ChangeHospitalRoomTypePutRequest = async (
//   tpaBillMappingId: number,
//   healthCareId: number,
//   schemeMetaDataId: number,
//   hospitalRoomType: string
// ): Promise<any> => {
//   try {
//     const payload = {
//       tpaBillMappingId,
//       healthCareId,
//       schemeMetaDataId,
//       hospitalRoomType,
//     };
//     const resp = await Axios.put<any>(
//       BILLING_APIS.UpdateHospitalRoomTypePutApi,
//       payload
//     );
//     return resp.data;
//   } catch (error: any) {
//     const errorMsg =
//       error?.response?.data?.message || "Cannot update hospital room type";
//     errorMessage(errorMsg);
//     // throw new Error(errorMsg);
//   }
// };

export const DownloadTPABillItems = async (
  tpaBillMappingId: number,
  type: string
): Promise<any> => {
  try {
    const payload = {
      tpaBillMappingId,
      type,
    };
    const resp = await Axios.post<any>(
      BILLING_APIS.DownloadTPABillItems,
      payload,
      {
        responseType: "arraybuffer",
      }
    );
    return resp;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || `Cannot get ${type} bill items`;
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const GetTPAMappedCollections = async (): Promise<any> => {
  try {
    const resp = await Axios.get<any>(BILLING_APIS.GetTPAMappedCollections);
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message ||
      "Cannot get categories & sub categories for the bill";
    errorMessage(errorMsg);
  }
};

// export const GetTPASubCollections = async (): Promise<any> => {
//   try {
//     const resp = await Axios.get<any>(BILLING_APIS.GetTPASubCollections);
//     return resp.data;
//   } catch (error: any) {
//     const errorMsg =
//       error?.response?.data?.message ||
//       "Cannot get sub categories for the bill";
//     errorMessage(errorMsg);
//   }
// };

export const GetTPADSBillCompData = async (tpaBillMappingId: number) => {
  try {
    const resp = await Axios.post<any>(BILLING_APIS.GetTPADSBillCompData, {
      tpaBillMappingId,
    });
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message ||
      "Cannot get discharge summary & bill comparison data";
    warningMessageModal(errorMsg);
  }
};

export const GetTPARoomTypeData = async (
  healthCareId: number,
  schemeMetaDataId: number
) => {
  try {
    const resp = await Axios.get<any>(
      `${BILLING_APIS.GetTPARoomType}/healthCare/${healthCareId}/scheme/${schemeMetaDataId}`
    );
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot get room type data";
    errorMessage(errorMsg);
  }
};

export const GetHospitalRoomTypeData = async (
  healthCareId: number
  // schemeMetaDataId: number
) => {
  try {
    const resp = await Axios.get<any>(
      `${BILLING_APIS.GetHospitalRoomType}/healthCare/${healthCareId}`
    );
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot get hospital room type data";
    errorMessage(errorMsg);
  }
};

export const GetAllSchemesData = async (healthCareId: number) => {
  try {
    const resp = await Axios.get<any>(
      `${BILLING_APIS.GetAllSchemes}/health_care/${healthCareId}`
    );
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot get all schemes data";
    errorMessage(errorMsg);
  }
};

export const deleteTPAPatientBills = async (
  tpaBillIdsToDelete: number[]
): Promise<any> => {
  try {
    const payload = {
      tpaBillIdsToDelete,
    };
    const resp = await Axios.put<any>(
      BILLING_APIS.DeleteTPAPatientBills,
      payload
    );
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot delete selected bills";
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const GetTPAHospitalProcedures = async (
  hospitalId: number,
  roomCategory?: string
) => {
  try {
    const resp = await Axios.post<any>(BILLING_APIS.GetHospitalProcedures, {
      healthCareId: hospitalId,
      roomCategory: roomCategory,
    });
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot get hospital procedures data";
    errorMessage(errorMsg);
  }
};

export const GetTPAInsuranceProcedures = async (
  hospitalId: number,
  schemeId: number, // scheme id selected in filter dropdown (SCHEME)
  roomCategory?: string
) => {
  try {
    const resp = await Axios.post<any>(BILLING_APIS.GetInsuranceProcedures, {
      healthCareId: hospitalId,
      schemeId,
      roomCategory,
    });
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot get insurance procedures data";
    errorMessage(errorMsg);
  }
};

export const PostCorrectedHospitalProcedure = async ({
  hospitalId,
  receivedProcedure,
  unmatchedProcedure,
  matchedProcedureId,
  matchedProcedure,
  billItemId,
  roomId,
  matchedProcedureRate,
}: {
  hospitalId: number;
  receivedProcedure: string;
  unmatchedProcedure: string;
  matchedProcedureId?: number | null;
  matchedProcedure?: string;
  billItemId: number;
  roomId?: number | null;
  matchedProcedureRate?: any;
}) => {
  try {
    const payload = {
      hospitalId,
      receivedProcedure,
      unmatchedProcedure,
      matchedProcedureId,
      matchedProcedure,
      tpaBillItemId: billItemId,
      roomId,
      matchedProcedureRate,
    };
    const resp = await Axios.post<any>(
      BILLING_APIS.PostCorrectedHospitalProcedures,
      payload
    );
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message ||
      "Cannot correct hospital procedures data";
    errorMessage(errorMsg);
  }
};

export const PostCorrectedInsuranceProcedure = async ({
  hospitalId,
  schemeId, // scheme id selected in filter dropdown (SCHEME)
  receivedProcedure,
  unmatchedProcedure,
  matchedProcedureId,
  matchedProcedure,
  billItemId,
  roomId,
  matchedProcedureRate,
  inclusions,
  exclusions,
}: {
  hospitalId: number;
  schemeId: number;
  receivedProcedure: string;
  unmatchedProcedure: string;
  matchedProcedureId?: number | null;
  matchedProcedure: string;
  billItemId: number;
  roomId?: number | null;
  matchedProcedureRate?: any;
  inclusions?: any;
  exclusions?: any;
}) => {
  try {
    const payload = {
      hospitalId,
      schemeId,
      receivedProcedure,
      unmatchedProcedure,
      matchedProcedureId,
      matchedProcedure,
      tpaBillItemId: billItemId,
      roomId,
      matchedProcedureRate,
      inclusions,
      exclusions,
    };
    const resp = await Axios.post<any>(
      BILLING_APIS.PostCorrectedInsuranceProcedures,
      payload
    );
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message ||
      "Cannot correct insurance procedures data";
    errorMessage(errorMsg);
  }
};

export const GetAllTPABillItems = async ({
  pageNumber,
  pageSize,
  query,
}: {
  pageNumber: number;
  pageSize: number;
  query?: any;
}) => {
  try {
    const payload = {
      pageNumber: pageNumber - 1,
      pageSize,
      orderBy: "id",
      direction: "desc",
      query: query || "",
    };
    const resp = await Axios.post<any>(BILLING_APIS.AllTPABillItems, payload);
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot get all TPA Bill Items";
    errorMessage(errorMsg);
  }
};

export const UpdateTPABillItem = async (billItem: any) => {
  try {
    const payload = {
      ...billItem,
    };
    const resp = await Axios.put<any>(BILLING_APIS.UpdateTPABillItem, payload);
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot update TPA Bill Item";
    errorMessage(errorMsg);
  }
};

export const PostDischargeSummaryUpdatedItemsTPA = async (
  tpaBillMappingId: number,
  updatedItems: any
): Promise<any> => {
  try {
    const payload = {
      tpaBillMappingId,
      updatedItems,
    };
    const resp = await Axios.post<any>(
      BILLING_APIS.TpaDischargeSummaryUpdatedItems,
      payload
    );
    return resp;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || `Cannot update discharge summary items`;
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};
